"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTION_CONFIGURATION_SCHEMA_JSON = exports.ACTION_TYPE = void 0;
exports.ACTION_TYPE = "'sns'";
exports.ACTION_CONFIGURATION_SCHEMA_JSON = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    title: 'AWS Simple Notification Service',
    type: 'object',
    required: ['topic_arn', 'region'],
    properties: {
        access_key: {
            type: 'string',
            'ui:title': 'Access Key',
            'ui:redactAuditLog': true,
        },
        secret_key: {
            type: 'string',
            'ui:title': 'Secret Key',
            'ui:secret': true,
            'ui:redactAuditLog': true,
        },
        role_arn: {
            type: 'string',
            'ui:title': 'Assume Role ARN',
        },
        topic_arn: {
            type: 'string',
            'ui:title': 'Topic ARN',
        },
        region: {
            type: 'string',
            'ui:title': 'Region',
        },
    },
};
